console.log("summus-core.js loaded");

function SummusCore() {
    console.log("Initializing SummusCore");

    function SummusPromise() {
        return {
            create: function (callback) {
                console.log("SummusPromise.create called");
                if (typeof callback === 'function') {
                    return new Promise(function (resolvePromiseCallback, rejectPromiseCallback) {
                        window._resolver = resolvePromiseCallback;
                        window._rejecter = rejectPromiseCallback;
                        try {
                            callback();
                        } catch (error) {
                            SummusCore().internalErrorHandler({ context: this, error: { isError: true, message: error } });
                        }
                    });
                }
            },
            resolve: function (result) {
                console.log("SummusPromise.resolve called with result:", result);
                var resolvePromiseCallback = window._resolver;
                if (typeof resolvePromiseCallback === 'function') {
                    resolvePromiseCallback(result);
                    SummusCore().internalCompletionHandler({ context: this, result: result });
                }
            },
            reject: function (reason) {
                console.error("SummusPromise.reject called with reason:", reason);
                var rejectPromiseCallback = window._rejecter;
                if (typeof rejectPromiseCallback === 'function' && typeof reason === 'string') {
                    rejectPromiseCallback(reason);
                    SummusCore().internalErrorHandler({ context: this, error: { isError: true, message: reason } });
                }
            }
        };
    }

    return {
        internalErrorHandler: function (argumentsObject) {
            console.error("Error Handler Called:", argumentsObject);
        },
        internalCompletionHandler: function (argumentsObject) {
            console.log("Completion Handler Called:", argumentsObject);
        },
        register: function (registerArray) {
            console.log("Registering functions/assets:", registerArray);
            if (typeof registerArray === 'object') {
                const appRegisterPromise = new SummusPromise();
                window.appRegisterPromises = window.appRegisterPromises || [];
                window.appRegisterPromises.push(appRegisterPromise.create(async () => {
                    for (let item of registerArray) {
                        if (item.asset) {
                            await this.loadAssets(item.asset);
                        }
                        if (item.function) {
                            try {
                                item.function();
                            } catch (error) {
                                console.error("Error in registered function:", error);
                            }
                        }
                    }
                    console.log("All registered assets/functions processed successfully");
                    return appRegisterPromise.resolve(registerArray);
                }));
            }
        },
        init: function (callback) {
            console.log("SummusCore.init called, checking document.readyState");

            // Check if document.readyState is already 'complete' or 'interactive'
            if (document.readyState === "complete" || document.readyState === "interactive") {
                console.log("DOM is already loaded, calling callback immediately.");
                if (callback) callback();
            } else {
                // Otherwise, wait for DOMContentLoaded
                document.addEventListener("DOMContentLoaded", function () {
                    console.log("DOMContentLoaded event triggered, calling callback if provided");
                    if (callback) callback();
                });
            }
        },
        ready: function (callback) {
            console.log("SummusCore.ready called");
            if (window.appReadyState) {
                window.appReadyState.then(function (response) {
                    console.log("appReadyState resolved:", response);
                    if (response.appReadyStateIsReady && callback) {
                        callback();
                    }
                }).catch(error => {
                    console.error("Error resolving appReadyState:", error);
                });
            } else {
                console.warn("appReadyState not defined or not resolved");
            }
        },
        loadAssets: function (assets) {
            console.log("Loading assets:", assets);
            const loadPromises = assets.map(asset => {
                return new Promise((resolve, reject) => {
                    const element = document.createElement(asset.type);
                    Object.keys(asset.attr).forEach(key => {
                        element[key] = asset.attr[key];
                    });
                    element.onload = () => {
                        console.log("Loaded asset:", asset.attr.src || asset.attr.href);
                        resolve();
                    };
                    element.onerror = () => {
                        console.error("Failed to load asset:", asset.attr.src || asset.attr.href);
                        reject();
                    };
                    document.body.appendChild(element);

                    // Add a timeout fallback to prevent indefinite waiting
                    setTimeout(() => {
                        if (!element.complete) {
                            console.warn("Asset load timed out:", asset.attr.src || asset.attr.href);
                            reject();
                        }
                    }, 5000); // 5-second timeout per asset
                });
            });
            return Promise.all(loadPromises);
        }
    };
}
